'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'square-binary';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e69b';
var svgPathData = ['M32 96l0 320c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L96 32C60.7 32 32 60.7 32 96zm100 48c0-24.3 19.7-44 44-44l32 0c24.3 0 44 19.7 44 44l0 48c0 24.3-19.7 44-44 44l-32 0c-24.3 0-44-19.7-44-44l0-48zm32 152c0-11 9-20 20-20l16 0c11 0 20 9 20 20l0 96c0 11-9 20-20 20s-20-9-20-20l0-76.4c-9.1-1.9-16-9.9-16-19.6zm8-152l0 48c0 2.2 1.8 4 4 4l32 0c2.2 0 4-1.8 4-4l0-48c0-2.2-1.8-4-4-4l-32 0c-2.2 0-4 1.8-4 4zm88 176c0-24.3 19.7-44 44-44l32 0c24.3 0 44 19.7 44 44l0 48c0 24.3-19.7 44-44 44l-32 0c-24.3 0-44-19.7-44-44l0-48zm32-200c0-11 9-20 20-20l16 0c11 0 20 9 20 20l0 96c0 11-9 20-20 20s-20-9-20-20l0-76.4c-9.1-1.9-16-9.9-16-19.6zm8 200l0 48c0 2.2 1.8 4 4 4l32 0c2.2 0 4-1.8 4-4l0-48c0-2.2-1.8-4-4-4l-32 0c-2.2 0-4 1.8-4 4z', 'M132 144c0-24.3 19.7-44 44-44l32 0c24.3 0 44 19.7 44 44l0 48c0 24.3-19.7 44-44 44l-32 0c-24.3 0-44-19.7-44-44l0-48zm44-4c-2.2 0-4 1.8-4 4l0 48c0 2.2 1.8 4 4 4l32 0c2.2 0 4-1.8 4-4l0-48c0-2.2-1.8-4-4-4l-32 0zm116-20c0-11 9-20 20-20l16 0c11 0 20 9 20 20l0 96c0 11-9 20-20 20s-20-9-20-20l0-76.4c-9.1-1.9-16-9.9-16-19.6zM164 296c0-11 9-20 20-20l16 0c11 0 20 9 20 20l0 96c0 11-9 20-20 20s-20-9-20-20l0-76.4c-9.1-1.9-16-9.9-16-19.6zm96 24c0-24.3 19.7-44 44-44l32 0c24.3 0 44 19.7 44 44l0 48c0 24.3-19.7 44-44 44l-32 0c-24.3 0-44-19.7-44-44l0-48zm44-4c-2.2 0-4 1.8-4 4l0 48c0 2.2 1.8 4 4 4l32 0c2.2 0 4-1.8 4-4l0-48c0-2.2-1.8-4-4-4l-32 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSquareBinary = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;